/* ==========================================================================
   Homellence – Produktseite
   Variantenwahl, Galerie, Warenkorb-Knopf, fester Balken am Handy.
   ========================================================================== */
(function () {
  'use strict';

  var HL = (window.HL = window.HL || {});

  /* ------------------------------------------------------------------
     <hl-gallery>  –  Wischgalerie mit Punkten und Vorschaubildern
     ------------------------------------------------------------------ */
  class HlGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hl-gallery-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-hl-gallery-slide]'));
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-hl-gallery-go]'));
      this.counter = this.querySelector('[data-hl-gallery-counter]');
      if (!this.track || !this.slides.length) return;

      var self = this;

      this.buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          self.goTo(parseInt(button.getAttribute('data-hl-gallery-go'), 10));
        });
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || entry.target.hidden) return;
              self.setCurrent(self.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach(function (slide) {
          self.observer.observe(slide);
        });
      }

      this.track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        self.step(event.key === 'ArrowRight' ? 1 : -1);
      });

      this.setUpLightbox();

      this.setCurrent(this.firstVisibleIndex());
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    /* ----------------------------------------------------------------
       C10 - Lightbox

       Wir benutzen <dialog> mit showModal(). Der Browser liefert damit die
       Rolle `dialog` samt `aria-modal`, den gefangenen Fokus und `Esc` zum
       Schliessen. Kennt ein Browser showModal() nicht, bleibt der Lupenknopf
       versteckt und das Bild bleibt ein Bild - lieber keine Funktion als
       eine halbe.
       ---------------------------------------------------------------- */
    setUpLightbox() {
      this.lightbox = this.querySelector('[data-hl-lightbox]');
      if (!this.lightbox || typeof this.lightbox.showModal !== 'function') return;

      var self = this;
      this.lightboxImage = this.lightbox.querySelector('[data-hl-lightbox-image]');
      this.lightboxCounter = this.lightbox.querySelector('[data-hl-lightbox-counter]');
      this.lightboxClose = this.lightbox.querySelector('[data-hl-lightbox-close]');
      this.lightboxNav = Array.prototype.slice.call(
        this.lightbox.querySelectorAll('[data-hl-lightbox-step]')
      );

      var zoomButton = this.querySelector('[data-hl-gallery-zoom]');
      if (zoomButton) {
        zoomButton.hidden = false;
        zoomButton.addEventListener('click', function () {
          self.openLightbox(self.current);
        });
      }
      this.classList.add('hl-gallery--zoomable');

      /* Klick auf das Bild oeffnet ebenfalls - aber nur, wenn es ein Klick
         war und kein Wischen. Der Schieber laeuft waagerecht; ohne diese
         Schwelle wuerde jede Wischgeste am Handy die Lightbox aufreissen. */
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      this.track.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
        startY = event.clientY;
        startScroll = self.track.scrollLeft;
      });
      this.track.addEventListener('click', function (event) {
        var slide = event.target.closest ? event.target.closest('[data-hl-gallery-slide]') : null;
        if (!slide || !slide.getAttribute('data-hl-zoom')) return;
        if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) return;
        if (Math.abs(self.track.scrollLeft - startScroll) > 4) return;
        self.openLightbox(self.slides.indexOf(slide));
      });

      this.lightboxNav.forEach(function (button) {
        button.addEventListener('click', function () {
          self.lightboxStep(parseInt(button.getAttribute('data-hl-lightbox-step'), 10));
        });
      });

      if (this.lightboxClose) {
        this.lightboxClose.addEventListener('click', function () {
          self.lightbox.close();
        });
      }

      /* Klick auf den Grund neben dem Bild schliesst. Der Dialog selbst ist
         das Ziel nur dann, wenn daneben geklickt wurde. */
      this.lightbox.addEventListener('click', function (event) {
        if (event.target === self.lightbox) self.lightbox.close();
      });

      /* Pfeiltasten und Esc.

         Esc koennte der Browser allein erledigen - <dialog> kennt die
         Schliess-Anfrage. Wir fangen die Taste trotzdem selbst ab, aus zwei
         Gruenden: Erstens haengt der eingebaute Weg an einem Pfad, der sich
         von aussen nicht zuverlaessig ausloesen und damit nicht belegen
         laesst; beim Messen am 15.09. kam der Tastendruck am Dokument an
         (`defaultPrevented: false`), ein `cancel`-Ereignis folgte aber
         nicht. Zweitens ist ein eigener Aufruf von close() harmlos: Der
         Dialog schliesst genau einmal. */
      this.lightbox.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          self.lightbox.close();
          return;
        }
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        self.lightboxStep(event.key === 'ArrowRight' ? 1 : -1);
      });

      var touchX = null;
      this.lightbox.addEventListener('touchstart', function (event) {
        touchX = event.changedTouches[0].clientX;
      }, { passive: true });
      this.lightbox.addEventListener('touchend', function (event) {
        if (touchX === null) return;
        var delta = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(delta) < 40) return;
        self.lightboxStep(delta < 0 ? 1 : -1);
      }, { passive: true });

      /* Rueckkehr des Fokus. <dialog> gibt den Fokus von sich aus an das
         Element zurueck, das ihn beim Oeffnen hatte - beim Klick auf das
         Bild ist das aber nicht der Lupenknopf, sondern gar nichts. Deshalb
         merken wir uns beim Oeffnen selbst, wohin zurueck. */
      this.lightbox.addEventListener('close', function () {
        var back = self.lightboxReturn;
        self.lightboxReturn = null;
        if (back && document.contains(back) && typeof back.focus === 'function') back.focus();
      });
    }

    /* Nur sichtbare Folien, die ein grosses Bild mitbringen. Videos und
       3D-Modelle bleiben aussen vor. */
    zoomIndexes() {
      var out = [];
      for (var i = 0; i < this.slides.length; i += 1) {
        if (!this.slides[i].hidden && this.slides[i].getAttribute('data-hl-zoom')) out.push(i);
      }
      return out;
    }

    openLightbox(index) {
      if (!this.lightbox) return;
      var zoomable = this.zoomIndexes();
      if (!zoomable.length) return;
      if (zoomable.indexOf(index) === -1) index = zoomable[0];

      this.lightboxReturn = document.activeElement;
      this.showInLightbox(index);
      this.lightbox.showModal();
      if (this.lightboxClose) this.lightboxClose.focus();
    }

    lightboxStep(direction) {
      var zoomable = this.zoomIndexes();
      var position = zoomable.indexOf(this.lightboxIndex);
      if (position === -1) position = 0;
      var next = position + direction;
      if (next < 0 || next >= zoomable.length) return;
      this.showInLightbox(zoomable[next]);
    }

    showInLightbox(index) {
      var slide = this.slides[index];
      if (!slide) return;
      this.lightboxIndex = index;

      if (this.lightboxImage) {
        this.lightboxImage.src = slide.getAttribute('data-hl-zoom');
        this.lightboxImage.alt = slide.getAttribute('data-hl-zoom-alt') || '';
        /* Die echten Masse ersetzen die Platzhalter aus dem Markup. Die
           stehen dort nur, weil `theme check` (ImgWidthAndHeight) sie
           verlangt; das Seitenverhaeltnis kommt erst hier. */
        var breite = slide.getAttribute('data-hl-zoom-w');
        var hoehe = slide.getAttribute('data-hl-zoom-h');
        if (breite && hoehe) {
          this.lightboxImage.width = parseInt(breite, 10);
          this.lightboxImage.height = parseInt(hoehe, 10);
        }
      }

      var zoomable = this.zoomIndexes();
      var position = zoomable.indexOf(index);
      if (this.lightboxCounter) {
        this.lightboxCounter.textContent = this.lightboxCounter
          .getAttribute('data-format')
          .replace('[current]', position + 1)
          .replace('[total]', zoomable.length);
      }

      this.lightboxNav.forEach(function (button) {
        var step = parseInt(button.getAttribute('data-hl-lightbox-step'), 10);
        button.disabled = position + step < 0 || position + step >= zoomable.length;
      });

      /* Die Galerie darunter zieht mit, damit nach dem Schliessen dasselbe
         Bild steht wie in der grossen Ansicht. */
      this.goTo(index);
    }

    /* Sichtbare Folien in Reihenfolge - Grundlage für Zähler und Blättern. */
    visibleIndexes() {
      var out = [];
      for (var i = 0; i < this.slides.length; i += 1) {
        if (!this.slides[i].hidden) out.push(i);
      }
      return out;
    }

    firstVisibleIndex() {
      var visible = this.visibleIndexes();
      return visible.length ? visible[0] : 0;
    }

    /* Ein Schritt weiter oder zurück, nur über sichtbare Folien. */
    step(direction) {
      var visible = this.visibleIndexes();
      var position = visible.indexOf(this.current);
      if (position === -1) position = 0;
      var next = position + direction;
      if (next < 0 || next >= visible.length) return;
      this.goTo(visible[next]);
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      if (this.slides[index].hidden) return;
      this.slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      this.setCurrent(index);
    }

    /* Ohne Animation springen - beim Variantenwechsel. */
    jumpToMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < this.slides.length; i += 1) {
        if (this.slides[i].getAttribute('data-media-id') === String(mediaId) && !this.slides[i].hidden) {
          this.slides[i].scrollIntoView({ block: 'nearest', inline: 'center' });
          this.setCurrent(i);
          return;
        }
      }
    }

    /* Welche Folien gehoeren zu diesen Optionswerten?

       Dieselbe Regel wie in hl-product-gallery.liquid: Ein Medium gehoert
       dazu, wenn sein Alt-Text **alle** Optionswerte enthaelt. Bleibt nichts
       uebrig, gewinnt der Optionswert mit der kleinsten, nicht leeren
       Treffermenge; erst danach werden alle gezeigt. Eine leere Galerie darf
       nie entstehen. */
    matchIndexes(optionValues, mediaId) {
      var alts = this.slides.map(function (slide) {
        return slide.getAttribute('data-hl-alt') || '';
      });
      var all = alts.map(function (_, i) { return i; });

      /* Bevorzugt ueber das eigene Vorschaubild der Variante: sein Alt-Text
         ohne die Zaehlung „(image n)" ist der Gruppenschluessel. Das ist
         sprachunabhaengig - auf der deutschen Seite heisst der Optionswert
         „Weiß", der Alt-Text aber weiterhin „white". */
      if (mediaId) {
        var anchor = null;
        for (var a = 0; a < this.slides.length; a += 1) {
          if (this.slides[a].getAttribute('data-media-id') === String(mediaId)) {
            anchor = alts[a];
            break;
          }
        }
        if (anchor) {
          var key = anchor.split(' (image')[0].trim();
          if (key) {
            var group = all.filter(function (i) { return alts[i].indexOf(key) !== -1; });
            if (group.length) return group;
          }
        }
      }

      var needles = (optionValues || [])
        .filter(function (value) { return value; })
        .map(function (value) { return String(value).toLowerCase(); });

      if (!needles.length) return all;

      var strict = all.filter(function (i) {
        return needles.every(function (needle) { return alts[i].indexOf(needle) !== -1; });
      });
      if (strict.length) return strict;

      var best = null;
      needles.forEach(function (needle) {
        var hits = all.filter(function (i) { return alts[i].indexOf(needle) !== -1; });
        if (hits.length && (!best || hits.length < best.length)) best = hits;
      });

      return best || all;
    }

    /* Galerie auf eine Variante umstellen - die ganze Galerie, nicht nur das
       Hauptbild. Die Hoehe bleibt gleich, weil der Rahmen quadratisch ist. */
    showForVariant(variant) {
      if (this.getAttribute('data-hl-gallery-filter') === 'false') return;
      if (!variant) return;

      var wanted = this.matchIndexes(variant.options, variant.media_id);
      var show = {};
      wanted.forEach(function (i) { show[i] = true; });

      var changed = false;
      var lists = [
        this.slides,
        Array.prototype.slice.call(this.querySelectorAll('.hl-gallery__dots > li')),
        Array.prototype.slice.call(this.querySelectorAll('.hl-gallery__thumbs > li')),
      ];

      lists.forEach(function (nodes) {
        nodes.forEach(function (node, i) {
          var visible = Boolean(show[i]);
          if (node.hidden !== !visible) {
            node.hidden = !visible;
            changed = true;
          }
        });
      });

      if (!changed) return;

      var visible = this.visibleIndexes();
      if (visible.length && visible.indexOf(this.current) === -1) {
        this.slides[visible[0]].scrollIntoView({ block: 'nearest', inline: 'center' });
        this.setCurrent(visible[0]);
      } else {
        this.setCurrent(this.current);
      }
    }

    setCurrent(index) {
      if (index < 0) return;
      this.current = index;
      this.buttons.forEach(function (button) {
        var isCurrent = parseInt(button.getAttribute('data-hl-gallery-go'), 10) === index;
        button.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      });
      if (this.counter) {
        var visible = this.visibleIndexes();
        var position = visible.indexOf(index);
        this.counter.textContent = this.counter
          .getAttribute('data-format')
          .replace('[current]', position === -1 ? 1 : position + 1)
          .replace('[total]', visible.length);
      }
    }
  }

  if (!customElements.get('hl-gallery')) customElements.define('hl-gallery', HlGallery);

  /* ------------------------------------------------------------------
     <hl-product>  –  Variantenwahl und Warenkorb
     ------------------------------------------------------------------ */
  class HlProduct extends HTMLElement {
    connectedCallback() {
      var dataNode = this.querySelector('[data-hl-variants]');
      this.variants = dataNode ? JSON.parse(dataNode.textContent) : [];
      this.form = this.querySelector('[data-hl-product-form]');
      this.idInput = this.querySelector('input[name="id"]');
      this.gallery = this.querySelector('hl-gallery');
      this.stickyBar = document.querySelector('[data-hl-sticky-bar]');

      var self = this;

      this.addEventListener('change', function (event) {
        if (!event.target.matches('[data-hl-option-input]')) return;
        self.onOptionChange();
      });

      if (this.form) {
        this.form.addEventListener('submit', function (event) {
          self.onSubmit(event);
        });
      }

      this.setupStickyBar();
      this.onOptionChange(true);
    }

    get selectedValues() {
      return Array.prototype.map.call(
        this.querySelectorAll('[data-hl-option-group]'),
        function (group) {
          var checked = group.querySelector('[data-hl-option-input]:checked');
          return checked ? checked.value : null;
        }
      );
    }

    findVariant(values) {
      for (var i = 0; i < this.variants.length; i += 1) {
        var variant = this.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j += 1) {
          if (values[j] !== null && variant.options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return variant;
      }
      return null;
    }

    onOptionChange(initial) {
      var values = this.selectedValues;
      var variant = this.findVariant(values);
      this.currentVariant = variant;

      this.markUnavailableOptions(values);
      this.updateSelectedLabels();
      this.updatePrice(variant);
      this.updateBuyButton(variant);

      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;
      if (this.gallery) {
        this.gallery.showForVariant(variant);
        if (variant.media_id) this.gallery.jumpToMedia(variant.media_id);
      }

      if (!initial && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Optionswerte durchstreichen, die es mit der übrigen Auswahl nicht gibt. */
    markUnavailableOptions(values) {
      var self = this;
      Array.prototype.forEach.call(
        this.querySelectorAll('[data-hl-option-group]'),
        function (group, position) {
          Array.prototype.forEach.call(
            group.querySelectorAll('[data-hl-option-input]'),
            function (input) {
              var probe = values.slice();
              probe[position] = input.value;
              var match = self.findVariant(probe);
              var label = group.querySelector('label[for="' + input.id + '"]');
              var exists = Boolean(match && match.available);
              if (exists) {
                input.removeAttribute('aria-describedby');
                input.removeAttribute('aria-disabled');
              } else {
                input.setAttribute('aria-describedby', 'hl-unavailable');
                input.setAttribute('aria-disabled', 'true');
              }
              if (label) label.classList.toggle('hl-option__label--unavailable', !exists);
            }
          );
        }
      );
    }

    updateSelectedLabels() {
      Array.prototype.forEach.call(
        this.querySelectorAll('[data-hl-option-group]'),
        function (group) {
          var output = group.querySelector('[data-hl-option-selected]');
          var checked = group.querySelector('[data-hl-option-input]:checked');
          if (output && checked) output.textContent = checked.value;

          /* R3 - Der Punkt links vom Namen. Die Farbe steht am Radioknopf,
             aufgeloest in Liquid ueber hl-swatch-colour. Hier wird sie nur
             abgelesen - keine zweite Tabelle im JavaScript. */
          var dot = group.querySelector('[data-hl-option-dot]');
          if (dot) {
            var farbe = checked ? checked.getAttribute('data-hl-swatch') : null;
            dot.hidden = !farbe;
            if (farbe) dot.style.setProperty('--hl-swatch', farbe);
          }
        }
      );
    }

    updatePrice(variant) {
      var priceNode = this.querySelector('[data-hl-price]');
      var compareNode = this.querySelector('[data-hl-price-compare]');
      var stickyPrice = document.querySelector('[data-hl-sticky-price]');
      var stickyVariant = document.querySelector('[data-hl-sticky-variant]');

      if (priceNode && variant) priceNode.innerHTML = variant.price_html;
      if (compareNode) {
        if (variant && variant.compare_html) {
          compareNode.innerHTML = variant.compare_html;
          compareNode.hidden = false;
        } else {
          compareNode.hidden = true;
        }
      }
      if (stickyPrice && variant) stickyPrice.innerHTML = variant.price_html;
      /* C17b (Runde 48) · `label` statt `title`.

         `title` ist bei einem Produkt mit nur einer Variante "Default
         Title". `label` kommt aus `hl-card-title` und ist dort leer - genau
         wie beim ersten Aufbau der Seite. Faellt `label` einmal weg (alte
         Fassung im Cache), bleibt `title` als Rueckfall. */
      if (stickyVariant && variant) {
        stickyVariant.textContent = variant.label != null ? variant.label : variant.title;
      }
    }

    updateBuyButton(variant) {
      var buttons = document.querySelectorAll('[data-hl-add-button]');
      Array.prototype.forEach.call(buttons, function (button) {
        var text = button.querySelector('[data-hl-add-text]') || button;
        if (!variant) {
          button.disabled = true;
          text.textContent = button.getAttribute('data-label-unavailable');
        } else if (!variant.available) {
          button.disabled = true;
          text.textContent = button.getAttribute('data-label-sold-out');
        } else {
          button.disabled = false;
          text.textContent = button.getAttribute('data-label-add');
        }
      });

      /* D15 · Kein Bezahlangebot fuer etwas, das nicht kaufbar ist - auch
         nicht nach einem Variantenwechsel im Browser. Statt der Bezahlknoepfe
         steht dann der Satz aus C1. */
      var buyable = Boolean(variant && variant.available);
      var checkout = document.querySelector('[data-hl-dynamic-checkout]');
      if (checkout) checkout.hidden = !buyable;
      var hint = document.querySelector('[data-hl-sold-out-hint]');
      if (hint) hint.hidden = buyable;
    }

    setupStickyBar() {
      if (!this.stickyBar) return;
      var anchor = this.querySelector('[data-hl-sticky-anchor]');
      if (!anchor || !('IntersectionObserver' in window)) return;
      var bar = this.stickyBar;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { rootMargin: '0px 0px -100% 0px', threshold: 0 }
      ).observe(anchor);
    }

    onSubmit(event) {
      event.preventDefault();
      var button = this.form.querySelector('[data-hl-add-button]');
      var self = this;
      if (button) button.setAttribute('aria-busy', 'true');

      var body = new FormData(this.form);
      body.append('sections', 'hl-cart-drawer,hl-header');
      body.append('sections_url', window.location.pathname);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body,
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            self.showError(result.data && result.data.description);
            return;
          }
          self.showError(null);
          HL.applyCartSections(result.data.sections);
          HL.toast();
          var drawer = document.querySelector('#hl-cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open(button);
        })
        .catch(function () {
          self.showError(null);
        })
        .finally(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    }

    showError(message) {
      var node = this.querySelector('[data-hl-form-error]');
      if (!node) return;
      node.textContent = message || '';
      node.hidden = !message;
    }
  }

  if (!customElements.get('hl-product')) customElements.define('hl-product', HlProduct);
})();
